import { render, staticRenderFns } from "./FollowUp.vue?vue&type=template&id=a22033a8&scoped=true"
import script from "./FollowUp.vue?vue&type=script&lang=js"
export * from "./FollowUp.vue?vue&type=script&lang=js"
import style0 from "./FollowUp.vue?vue&type=style&index=0&id=a22033a8&prod&scoped=true&lang=css"
import style1 from "./FollowUp.vue?vue&type=style&index=1&id=a22033a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a22033a8",
  null
  
)

export default component.exports